import { Col, Row } from "react-bootstrap";
import React, { useState } from "react";
import LanguageContainer from "../redux/containers/LanguageContainer";
import VariablesValueContainer from "../redux/containers/VariablesValueContainer";
import StructureContainer from "../redux/containers/StructureContainer";
import ExpressionsContainer from "../redux/containers/ExpressionsContainer";
import SplitPane from 'react-split-pane';

const Pane = ({
  minSize,
  ...props
}) => /*#__PURE__*/React.createElement("div", props);

export class MathSystem extends React.Component {
  state = {
    width: window.innerWidth
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.syncMathState();
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      width: window.innerWidth
    });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  isSplitVertically() {
    return this.state.width > 991.9;
  }

  paneMinSize() {
    return this.isSplitVertically() ? '240px' : '80px';
  }

  render() {
    return /*#__PURE__*/React.createElement(SplitPane, {
      split: this.isSplitVertically() ? 'vertical' : 'horizontal',
      allowResize: true,
      className: "split-pane",
      resizerStyle: {
        background: 'white'
      },
      paneStyle: {
        background: 'white'
      }
    }, /*#__PURE__*/React.createElement(Pane, {
      minSize: this.paneMinSize(),
      className: "overflow-auto vh-pane-left"
    }, /*#__PURE__*/React.createElement(LanguageContainer, null), /*#__PURE__*/React.createElement(StructureContainer, null), /*#__PURE__*/React.createElement(VariablesValueContainer, null)), /*#__PURE__*/React.createElement(Pane, {
      minSize: this.paneMinSize(),
      className: "overflow-auto vh-pane-right"
    }, /*#__PURE__*/React.createElement(ExpressionsContainer, {
      diagramModel: this.props.diagramModel
    })));
  }

}